import { createAction } from '@reduxjs/toolkit';
import type { BoundaryFilter } from '../boundary/mapSettingsToolsStateBoundary.state';
import type { DataLayersFilterKey } from './mapSettingsToolsStateDataLayers.state';

export const setDataLayersFilter = createAction(
  'SET_DATA_LAYERS_FILTER',
  (filterKey: DataLayersFilterKey, filter: BoundaryFilter) => ({
    payload: {
      filterKey,
      filter,
    },
  })
);
